export default "__VITE_ASSET__CXgw19uF__"